(function () {
  function actualizarHeader() {
    const header = document.querySelector('header-component');

    if (window.scrollY > 80) {
      document.body.classList.add('jm-scrolled');

      if (header) {
        header.style.setProperty('display', 'none', 'important');
      }
    } else {
      document.body.classList.remove('jm-scrolled');

      if (header) {
        header.style.removeProperty('display');
      }
    }
  }

  window.addEventListener('scroll', actualizarHeader, { passive: true });
  actualizarHeader();
})();